/* global subscribe, PUB_SUB_EVENTS */

(() => {
  if (window.pfBoostOfferClassicInitialized) return;
  window.pfBoostOfferClassicInitialized = true;

  const ROOT_SELECTOR = "[data-pf-boost-offer-classic]";
  const INPUT_NAME = "pf_scroll_complementary_variant_id[]";
  const stateByOffer = new Map();

  const offerKey = (root) => root.dataset.pfBoostVariantId || "boost";

  const stateFor = (root) => {
    const key = offerKey(root);
    if (!stateByOffer.has(key)) {
      stateByOffer.set(key, { selected: false, declined: false });
    }
    return stateByOffer.get(key);
  };

  const productForm = (root) =>
    root.closest("form") ||
    document.querySelector(
      'product-info:not([data-pf-scroll-product-info]) product-form form[data-type="add-to-cart-form"]'
    );

  const productForms = (root) => {
    const owner = root.closest("product-info");
    if (!owner) return [productForm(root)].filter(Boolean);
    return Array.from(owner.querySelectorAll('product-form form[data-type="add-to-cart-form"]'));
  };

  const syncFormInputs = (root) => {
    const state = stateFor(root);
    const variantId = root.dataset.pfBoostVariantId;
    productForms(root).forEach((form) => {
      const inputs = Array.from(form.querySelectorAll('[data-pf-boost-offer-input="true"]'));
      const isSynced = state.selected
        ? inputs.length === 1 && inputs[0].value === variantId
        : inputs.length === 0;
      if (isSynced) return;

      inputs.forEach((input) => input.remove());
      if (!state.selected || !variantId) return;

      const input = document.createElement("input");
      input.type = "hidden";
      input.name = INPUT_NAME;
      input.value = variantId;
      input.dataset.pfBoostOfferInput = "true";
      form.appendChild(input);
    });
  };

  const renderState = (root) => {
    const state = stateFor(root);
    const claim = root.querySelector("[data-pf-boost-offer-claim]");
    const decline = root.querySelector("[data-pf-boost-offer-decline]");

    root.dataset.pfBoostSelected = state.selected ? "true" : "false";
    root.dataset.pfBoostDeclined = state.declined ? "true" : "false";
    claim?.classList.toggle("is-selected", state.selected);
    claim?.setAttribute("aria-pressed", state.selected ? "true" : "false");
    decline?.classList.toggle("is-selected", state.declined);
    decline?.setAttribute("aria-pressed", state.declined ? "true" : "false");
    syncFormInputs(root);
  };

  const initialize = (root) => {
    if (!root || root.dataset.pfBoostInitialized === "true") return;
    root.dataset.pfBoostInitialized = "true";

    root.addEventListener("click", (event) => {
      const state = stateFor(root);
      const claim = event.target.closest("[data-pf-boost-offer-claim]");
      if (claim && root.contains(claim)) {
        event.preventDefault();
        state.selected = true;
        state.declined = false;
        renderState(root);
        return;
      }

      const decline = event.target.closest("[data-pf-boost-offer-decline]");
      if (decline && root.contains(decline)) {
        event.preventDefault();
        state.selected = false;
        state.declined = true;
        renderState(root);
        return;
      }

      const remove = event.target.closest("[data-pf-boost-offer-remove]");
      if (remove && root.contains(remove)) {
        event.preventDefault();
        state.selected = false;
        state.declined = false;
        renderState(root);
      }
    });

    renderState(root);
  };

  const initializeAll = (scope = document) => {
    const roots = [];
    if (scope.matches?.(ROOT_SELECTOR)) roots.push(scope);
    scope.querySelectorAll?.(ROOT_SELECTOR).forEach((root) => roots.push(root));
    roots.forEach((root) => {
      initialize(root);
      renderState(root);
    });
  };

  const queueRefresh = () => {
    window.requestAnimationFrame(() => initializeAll());
    [80, 250, 600, 1200, 2000].forEach((delay) => window.setTimeout(() => initializeAll(), delay));
  };

  document.addEventListener("DOMContentLoaded", () => initializeAll());
  document.addEventListener("shopify:section:load", (event) => initializeAll(event.target));
  document.addEventListener("change", (event) => {
    if (event.target.closest?.('variant-selects:not([data-upsell-isolated="true"])')) {
      queueRefresh();
    }
  });

  if (typeof subscribe === "function" && typeof PUB_SUB_EVENTS !== "undefined") {
    subscribe(PUB_SUB_EVENTS.variantChange, queueRefresh);
  }
})();
